import { getRootPluaralTranslator } from '@utils/get-module-translator'
import { generateId } from '@utils/id'

const __tc = getRootPluaralTranslator()

export const snmpProperyFieldMap = () => ({
  snmp_property_group: {
    title: __tc('snmp_property_group'),
    fields: [
      {
        key: generateId(),
        paramName: 'systemOID',
        name: __tc('system_oid'),
        inputType: 'text',
        rules: {
          system_oid: true,
        },
      },
      {
        key: generateId(),
        paramName: 'systemUpTime',
        name: __tc('system_up_time'),
        inputType: 'timePicker',
      },
      {
        key: generateId(),
        paramName: 'firmware',
        name: __tc('firmware'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'firmwareVersion',
        name: __tc('firmware_version'),
        inputType: 'text',
      },
      {
        key: generateId(),
        paramName: 'port',
        name: __tc('port'),
        inputType: 'number',
        rules: {
          port: true,
          numeric: true,
        },
      },
      {
        key: generateId(),
        paramName: 'manufacturerId',
        name: __tc('manufacturer'),
        inputType: 'manufacturer',
      },
      {
        key: generateId(),
        paramName: 'contactName',
        name: __tc('contact_name'),
        inputType: 'text',
      },
    ],
  },
})
